(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["duo-reader"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDuo(root) {
    if (!root || root.dataset.fwdInitialized === 'true') return;
    root.dataset.fwdInitialized = 'true';
    root.classList.add('fwd-js');

    var tabs = root.querySelectorAll('[data-format-tab]');
    var name = root.querySelector('[data-format-name]');
    var speed = root.querySelector('[data-format-interface]');
    var detail = root.querySelector('[data-format-detail]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (item) { item.setAttribute('aria-selected', item === tab ? 'true' : 'false'); });
        if (name) name.textContent = tab.dataset.name || '';
        if (speed) speed.textContent = tab.dataset.interface || '';
        if (detail) detail.textContent = tab.dataset.detail || '';
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var current = Array.prototype.indexOf.call(tabs, tab);
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = (current + direction + tabs.length) % tabs.length;
        tabs[next].focus();
        tabs[next].click();
      });
    });

    var reveals = root.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (item) { item.dataset.visible = 'true'; });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.dataset.visible = 'true';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (item) { observer.observe(item); });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-freewell-duo]').forEach(initDuo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["freewell-16mm-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setPanels = (root, type, id) => {
      const tabs = root.querySelectorAll(`[data-fw-${type}-tab]`);
      const panels = root.querySelectorAll(`[data-fw-${type}-panel]`);
      const update = () => {
        tabs.forEach((tab) => {
          tab.setAttribute('aria-selected', String(tab.dataset[`fw${type[0].toUpperCase()}${type.slice(1)}Tab`] === id));
        });
        panels.forEach((panel) => {
          const active = panel.dataset[`fw${type[0].toUpperCase()}${type.slice(1)}Panel`] === id;
          panel.hidden = !active;
          panel.querySelectorAll('video').forEach((video) => {
            if (active) video.play().catch(() => {});
            else video.pause();
          });
        });
      };
      update();
    };

    const init = (root) => {
      if (!root || root.dataset.fw16Ready === 'true') return;
      root.dataset.fw16Ready = 'true';

      root.querySelectorAll('[data-fw-photo-tab]').forEach((tab) => {
        tab.addEventListener('click', () => setPanels(root, 'photo', tab.dataset.fwPhotoTab));
      });

      root.querySelectorAll('[data-fw-video-tab]').forEach((tab) => {
        tab.addEventListener('click', () => setPanels(root, 'video', tab.dataset.fwVideoTab));
      });

      root.querySelectorAll('[data-fw-comparison-range]').forEach((range) => {
        range.addEventListener('input', () => {
          range.closest('[data-fw-photo-panel]').style.setProperty('--reveal', `${range.value}%`);
        });
      });

      root.querySelectorAll('[data-fw-video-panel][hidden] video').forEach((video) => video.pause());
    };

    document.querySelectorAll('[data-fw16-section]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      init(event.target.querySelector('[data-fw16-section]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["freewell-17x-telephoto-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll("[data-fw-telephoto]").forEach((root) => {
        if (root.dataset.fwReady === "true") return;
        root.dataset.fwReady = "true";

        const autoplayVideos = Array.from(root.querySelectorAll("[data-fw-autoplay]"));
        const playVideo = (video) => {
          video.defaultMuted = true;
          video.muted = true;
          video.playsInline = true;
          if (video.readyState === 0) video.load();
          const playback = video.play();
          if (playback) {
            playback
              .then(() => {
                video.controls = false;
              })
              .catch(() => {
                video.controls = true;
              });
          }
        };

        if ("IntersectionObserver" in window) {
          const videoObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting) {
                  playVideo(video);
                } else {
                  video.pause();
                }
              });
            },
            { rootMargin: "480px 0px", threshold: 0.01 }
          );

          autoplayVideos.forEach((video) => videoObserver.observe(video));
        } else {
          autoplayVideos.forEach((video) => playVideo(video));
        }

        root.querySelectorAll("[data-fw-range]").forEach((range) => {
          range.addEventListener("input", () => {
            range.closest(".fw-telephoto__comparison").style.setProperty("--fw-reveal", `${range.value}%`);
          });
        });

        root.querySelectorAll("[data-fw-tabs]").forEach((tablist) => {
          const group = tablist.dataset.fwTabs;
          const tabs = Array.from(tablist.querySelectorAll("[role='tab']"));
          const panels = Array.from(root.querySelectorAll(`.${group === "photo" ? "fw-telephoto__photo-panel" : "fw-telephoto__motion-panel"}`));

          const activate = (tab, moveFocus = false) => {
            const update = () => {
              tabs.forEach((item) => {
                const active = item === tab;
                item.setAttribute("aria-selected", String(active));
                item.tabIndex = active ? 0 : -1;
              });

              panels.forEach((panel) => {
                const active = panel.dataset.fwPanel === tab.dataset.fwTab;
                panel.hidden = !active;
                if (group === "motion") {
                  panel.querySelectorAll("video").forEach((video) => {
                    if (active) {
                      playVideo(video);
                    } else {
                      video.pause();
                    }
                  });
                }
              });

              if (moveFocus) tab.focus();
            };

            update();
          };

          tabs.forEach((tab, index) => {
            tab.tabIndex = tab.getAttribute("aria-selected") === "true" ? 0 : -1;
            tab.addEventListener("click", () => activate(tab));
            tab.addEventListener("keydown", (event) => {
              let nextIndex = index;
              if (event.key === "ArrowRight") nextIndex = (index + 1) % tabs.length;
              if (event.key === "ArrowLeft") nextIndex = (index - 1 + tabs.length) % tabs.length;
              if (event.key === "Home") nextIndex = 0;
              if (event.key === "End") nextIndex = tabs.length - 1;
              if (nextIndex !== index) {
                event.preventDefault();
                activate(tabs[nextIndex], true);
              }
            });
          });
        });
      });
    };

    initialize();
    document.addEventListener("shopify:section:load", (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fuji-l-bracket"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initializeViewer(root) {
    if (!root || root.getAttribute('data-fw-lb-ready') === 'true') return;

    var finishButtons = root.querySelectorAll('[data-fw-finish]');
    var angleButtons = root.querySelectorAll('[data-fw-angle]');
    var productImage = root.querySelector('[data-fw-product-image]');
    var stageIndex = root.querySelector('[data-fw-stage-index]');
    var stageCaption = root.querySelector('[data-fw-stage-caption]');

    if (!productImage || !finishButtons.length || !angleButtons.length) return;

    root.setAttribute('data-fw-lb-ready', 'true');

    var state = {
      finish: 'black',
      angle: 'front'
    };

    function setPressed(buttons, activeValue, attributeName) {
      Array.prototype.forEach.call(buttons, function (button) {
        var isActive = button.getAttribute(attributeName) === activeValue;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function updateViewer() {
      var source = root.getAttribute('data-' + state.finish + '-' + state.angle);
      if (!source) return;

      productImage.classList.remove('is-changing');
      void productImage.offsetWidth;
      productImage.src = source;
      productImage.alt =
        state.finish.charAt(0).toUpperCase() + state.finish.slice(1) +
        ' Freewell L bracket for Fujifilm X100VI, ' + state.angle + ' view';
      productImage.classList.add('is-changing');

      if (stageIndex) {
        stageIndex.textContent = (state.finish === 'black' ? 'B' : 'S') + '—' +
          (state.angle === 'front' ? '01' : '02');
      }

      if (stageCaption) {
        stageCaption.textContent =
          (state.finish === 'black' ? 'Black' : 'Silver') + ' frame · Natural wood';
      }

      setPressed(finishButtons, state.finish, 'data-fw-finish');
      setPressed(angleButtons, state.angle, 'data-fw-angle');
    }

    Array.prototype.forEach.call(finishButtons, function (button) {
      button.addEventListener('click', function () {
        state.finish = button.getAttribute('data-fw-finish');
        updateViewer();
      });
    });

    Array.prototype.forEach.call(angleButtons, function (button) {
      button.addEventListener('click', function () {
        state.angle = button.getAttribute('data-fw-angle');
        updateViewer();
      });
    });

    ['black-front', 'black-rear', 'silver-front', 'silver-rear'].forEach(function (view) {
      var source = root.getAttribute('data-' + view);
      if (source) {
        var preload = new Image();
        preload.src = source;
      }
    });

    updateViewer();
  }

  function initializeAll(scope) {
    var parent = scope || document;
    var roots = parent.querySelectorAll
      ? parent.querySelectorAll('[data-fw-lb-section]')
      : [];

    Array.prototype.forEach.call(roots, initializeViewer);

    if (parent.matches && parent.matches('[data-fw-lb-section]')) {
      initializeViewer(parent);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fw-luna-kit"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.lunaKitReady) return;
    root.dataset.lunaKitReady = 'true';
    const tabs = [...root.querySelectorAll('[data-guide]')];
    const chooseTab = (tab) => {
      tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; const panel = root.querySelector(`#${item.getAttribute('aria-controls')}`); panel.hidden = !active; if (!active) panel.querySelectorAll('video').forEach(video => video.pause()); });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => chooseTab(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (next) { event.preventDefault(); chooseTab(next); next.focus(); }
      });
    });
    const familyButtons = [...root.querySelectorAll('[data-filter]')];
    const filterCards = [...root.querySelectorAll('[data-family]')];
    familyButtons.forEach(button => button.addEventListener('click', () => {
      const family = button.dataset.filter;
      familyButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      filterCards.forEach(card => card.hidden = family !== 'all' && card.dataset.family !== family);
      const visible = filterCards.filter(card => !card.hidden).length;
      root.querySelector('[data-filter-status]').textContent = (root.dataset.filterLabel || 'Showing [count] filters.').replace('[count]', String(visible));
    }));
    const toggle = root.querySelector('[data-comparison-toggle]');
    const videos = [...root.querySelectorAll('[data-compare-video]')];
    const pauseVideos = () => { videos.forEach(video => video.pause()); toggle.setAttribute('aria-pressed', 'false'); toggle.innerHTML = `${root.dataset.playLabel || 'Play the comparison'} <span aria-hidden="true">▷</span>`; };
    toggle.addEventListener('click', async () => {
      if (toggle.getAttribute('aria-pressed') === 'true') { pauseVideos(); return; }
      toggle.disabled = true;
      for (const video of videos) {
        const source = video.querySelector('source');
        if (!source.src && source.dataset.src) { source.src = source.dataset.src; video.load(); }
      }
      const results = await Promise.allSettled(videos.map(video => video.play()));
      toggle.disabled = false;
      if (results.some(result => result.status === 'rejected')) {
        pauseVideos(); videos.forEach(video => video.controls = true);
        return;
      }
      toggle.setAttribute('aria-pressed', 'true');
      toggle.innerHTML = `${root.dataset.pauseLabel || 'Pause the comparison'} <span aria-hidden="true">Ⅱ</span>`;
    });
    document.addEventListener('visibilitychange', () => { if (document.hidden) pauseVideos(); });
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) pauseVideos(); }, {threshold: 0});
      videoObserver.observe(root.querySelector('#difference'));
      const buyObserver = new IntersectionObserver(entries => root.querySelector('.floating-buy').classList.toggle('is-hidden', entries[0].isIntersecting), {threshold: 0.12});
      buyObserver.observe(root.querySelector('#purchase'));
    }
  };
  const initAll = () => document.querySelectorAll('[data-luna-kit]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fw-luna-mega"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.lunaReady) return;
    root.dataset.lunaReady = 'true';
    const tabs = [...root.querySelectorAll('[data-guide]')];
    const chooseTab = (tab) => {
      tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; const panel = root.querySelector(`#${item.getAttribute('aria-controls')}`); panel.hidden = !active; if (!active) panel.querySelectorAll('video').forEach(video => video.pause()); });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => chooseTab(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (next) { event.preventDefault(); chooseTab(next); next.focus(); }
      });
    });
    root.querySelectorAll('[data-demo]').forEach(button => button.addEventListener('click', () => {
      const panel = root.querySelector('#panel-pl');
      const video = panel.querySelector('video');
      const source = video.querySelector('source');
      const demo = button.dataset.demo;
      video.pause();
      video.poster = button.dataset.posterSrc;
      source.src = button.dataset.videoSrc;
      video.setAttribute('aria-label', `Freewell ${demo.toUpperCase()} filter demonstration`);
      video.load();
      panel.querySelectorAll('[data-demo]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    const familyButtons = [...root.querySelectorAll('[data-filter]')];
    const filterCards = [...root.querySelectorAll('[data-family]')];
    familyButtons.forEach(button => button.addEventListener('click', () => {
      const family = button.dataset.filter;
      familyButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      filterCards.forEach(card => card.hidden = family !== 'all' && card.dataset.family !== family);
      const visible = filterCards.filter(card => !card.hidden).length;
      root.querySelector('[data-filter-status]').textContent = (root.dataset.filterLabel || 'Showing [count] filters.').replace('[count]', String(visible));
    }));
    const toggle = root.querySelector('[data-comparison-toggle]');
    const videos = [...root.querySelectorAll('[data-compare-video]')];
    const pauseVideos = () => { videos.forEach(video => video.pause()); toggle.setAttribute('aria-pressed', 'false'); toggle.innerHTML = `${root.dataset.playLabel || 'Play the comparison'} <span aria-hidden="true">▷</span>`; };
    toggle.addEventListener('click', async () => {
      if (toggle.getAttribute('aria-pressed') === 'true') { pauseVideos(); return; }
      toggle.disabled = true;
      for (const video of videos) {
        const source = video.querySelector('source');
        if (!source.src && source.dataset.src) { source.src = source.dataset.src; video.load(); }
      }
      const results = await Promise.allSettled(videos.map(video => video.play()));
      toggle.disabled = false;
      if (results.some(result => result.status === 'rejected')) {
        pauseVideos(); videos.forEach(video => video.controls = true);
        return;
      }
      toggle.setAttribute('aria-pressed', 'true');
      toggle.innerHTML = `${root.dataset.pauseLabel || 'Pause the comparison'} <span aria-hidden="true">Ⅱ</span>`;
    });
    document.addEventListener('visibilitychange', () => { if (document.hidden) pauseVideos(); });
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) pauseVideos(); }, {threshold: 0});
      videoObserver.observe(root.querySelector('#difference'));
      const buyObserver = new IntersectionObserver(entries => root.querySelector('.floating-buy').classList.toggle('is-hidden', entries[0].isIntersecting), {threshold: 0.12});
      buyObserver.observe(root.querySelector('#purchase'));
    }
  };
  const initAll = () => document.querySelectorAll('[data-luna]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leica-q3-43"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (!root || root.dataset.fqInitialized === "true") return;
    root.dataset.fqInitialized = "true";

    root.querySelectorAll('a[href^="#fq-"]').forEach((link) => {
      link.addEventListener("click", (event) => {
        const target = root.querySelector(link.getAttribute("href"));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
            ? "auto"
            : "smooth",
          block: "start"
        });
      });
    });

    const video = root.querySelector("video");
    if (video) {
      video.muted = true;
      video.playsInline = true;

      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.2 }
        );
        observer.observe(video);
      } else {
        video.play().catch(() => {});
      }
    }
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll("[data-fq-leica-page]").forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luna-ultra-wakit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const elements = root.querySelectorAll('.fw-luna-essential__reveal');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        elements.forEach((element) => element.classList.add('is-visible'));
        return;
      }

      root.classList.add('is-enhanced');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });

      elements.forEach((element) => observer.observe(element));
    };

    document.querySelectorAll('[data-fw-luna-essential]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-fw-luna-essential]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["op4p-wide-angle-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      root.querySelectorAll('img[data-fw-fallback-src]').forEach((image) => {
        let fallbackUsed = false;
        const useFallback = () => {
          if (fallbackUsed) return;
          fallbackUsed = true;
          image.src = image.dataset.fwFallbackSrc;
        };
        image.addEventListener('error', useFallback, { once: true });
        if (image.complete && image.naturalWidth === 0) useFallback();
      });

      const videoSection = root.querySelector('[data-fw-video-section]');
      root.querySelectorAll('[data-fw-auto-video]').forEach((video) => {
        const card = video.closest('[data-fw-auto-video-card]');
        const revealVideo = () => {
          card.classList.add('is-ready');
          videoSection.classList.add('is-ready');
        };
        video.addEventListener('loadedmetadata', revealVideo, { once: true });
        if (video.readyState >= 1) revealVideo();
      });

      const elements = root.querySelectorAll('.fw-op4p-v3__reveal');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        elements.forEach((element) => element.classList.add('is-visible'));
        return;
      }

      root.classList.add('is-enhanced');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });

      elements.forEach((element) => observer.observe(element));
    };

    document.querySelectorAll('[data-fw-op4p-v3]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-fw-op4p-v3]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
